import React from 'react'
import { Box } from 'components/layout/box'
import { Skeleton } from '@radix-ui/themes'
import * as styles from './Avatar.css'

export const MeetAvatarSkeleton = () => {
	return (
		<Box display="flex" alignItems="center" flexDirection="column" gap={1.5}>
			<Box className={styles.avatarTrader}>
				<Box className={styles.imgWrapper}>
					<Skeleton style={{ width: '100%', height: '100%', borderRadius: '50%' }} />
				</Box>
			</Box>

			<Skeleton style={{ width: '60px', height: '16px', borderRadius: '4px' }} />
		</Box>
	)
}
